import React from 'react';
import { ThemeContext } from './-theme-context';

export const useDecafTheme = () => React.useContext(ThemeContext);
